module.exports = __webpack_public_path__ + "static/media/Straight-Leg-Jeans_thumb.3cb93cec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/denim/Straight-Leg-Jeans_thumb.jpg
// module id = 143
// module chunks = 0